import React from 'react'
import PropTypes from 'prop-types'

const MCLoading = ({white} ) => {
    //animation-play-state: running; animation-delay: 0s;fill:var(--primary-color);
    const primaryQuad = {
        animationPlayState: 'running',
        animationDelay: 0 ,
        fill:white ? 'rgba(255,255,255,.6)' : 'var(--primary-color)',
    }

    const secondaryQuad = {
        ...primaryQuad ,
        fill:white ? 'rgba(255,255,255,.9)' : 'var(--secondary-color)',
    }

    return (
        <React.Fragment>
            <style>{`

            .c1 {
            display: flex;width: 100%; height: 100vh; justify-content: center;align-items: center; background-color: ##f9f9f9;
     opacity: 1 ; animation: fadeIn 1s ;}

        .c2 {
           padding: .5rem; border: 1px solid #a0a0a0;transform: rotate(-45deg) scale(.5);}

            `}
            </style>
            <div className='c1'>
                <div className="c2">

                    <svg width="105px" height="105px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                         preserveAspectRatio="xMidYMid" className="lds-cube"
                         style={primaryQuad}>
                        <g transform="translate(25,25)"
                           style={primaryQuad}>
                            <rect x="-20" y="-20" width="40" height="40"
                                  fill="#ff7c25" transform="scale(1.04705 1.04705)"
                                  style={primaryQuad}>
                                <animateTransform attributeName="transform" type="scale" calcMode="spline"
                                                  values="1.3;1" keyTimes="0;1"
                                                  dur="1.5s" keySplines="0 0.5 0.5 1"
                                                  begin="-0.44999999999999996s"
                                                  repeatCount="indefinite"
                                                  style={primaryQuad} />
                            </rect>
                        </g>
                        <g transform="translate(75,25)"
                           style={primaryQuad}>
                            <rect x="-20" y="-20" width="40" height="40"
                                  fill="#ff7c24"
                                  transform="scale(1.06873 1.06873)"
                                  style={primaryQuad}>
                                <animateTransform attributeName="transform" type="scale"
                                                  calcMode="spline"
                                                  values="1.3;1" keyTimes="0;1"
                                                  dur="1.5s" keySplines="0 0.5 0.5 1"
                                                  begin="-0.30000000000000004s"
                                                  repeatCount="indefinite"
                                                  style={primaryQuad} />
                            </rect>
                        </g>
                        <g transform="translate(25,75)"
                           style={primaryQuad}>
                            <rect x="-20" y="-20" width="40" height="40"
                                  fill="#ff7c24" transform="scale(1.13087 1.13087)"
                                  style={primaryQuad}>
                                <animateTransform attributeName="transform" type="scale" calcMode="spline"
                                                  values="1.3;1" keyTimes="0;1"
                                                  dur="1.5s" keySplines="0 0.5 0.5 1"
                                                  begin="0s"
                                                  repeatCount="indefinite"
                                                  style={primaryQuad} />
                            </rect>
                        </g>
                        <g transform="translate(75,75)"
                           style={secondaryQuad}>
                            <rect x="-20" y="-20" width="40" height="40"
                                  fill="#00579a" transform="scale(1.0957 1.0957)"
                                  style={secondaryQuad}>
                                <animateTransform attributeName="transform" type="scale" calcMode="spline"
                                                  values="1.3;1" keyTimes="0;1"
                                                  dur="1.5s" keySplines="0 0.5 0.5 1"
                                                  begin="-0.15000000000000002s"
                                                  repeatCount="indefinite"
                                                  style={secondaryQuad} />
                            </rect>
                        </g>
                    </svg>
                </div>

            </div>
        </React.Fragment>
    )
}

MCLoading.propTypes = {
    white: PropTypes.bool ,
}

MCLoading.defaultProps = {
    white:false
}

export default MCLoading



// WEBPACK FOOTER //
// ./src/components/_minha-central/Loading/index.js